import React, { Component } from "react";
import { connect } from "react-redux";
import Server from "./Server.js";
import { SelectButton } from "primereact/selectbutton";
import { ProgressSpinner } from "primereact/progressspinner";
import { Link } from "react-router-dom";
import Header from "./Header.js";
import { Tag } from "primereact/tag";

class ShopList extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef(); // Create a ref object
    this.Server = new Server();
    this.state = {
      list: [],
      shopGroups: [],
      ShowLoading: true,
      shopGroup: window.location.href.split("_id=")[1],
      absoluteUrl: this.Server.getAbsoluteUrl(),
    };
  }
  componentDidMount() {
    this.getshopsGroups();
    this.getshops(this.state.shopGroup);
  }
  getshopsGroups() {
    let that = this;
    that.setState({
      ShowLoading: 1,
    });
    this.Server.send(
      "AdminApi/getShopGroup",
      { linit: 10 },
      function (response) {
        let shopGroups = [];

        for (let i = 0; i < response.data.result.length; i++) {
          shopGroups.push({
            label: response.data.result[i].name,
            value: response.data.result[i]._id,
          });
        }
        that.setState({
          shopGroups: shopGroups,
        });
      },
      function () {}
    );
  }
  getshops(shopGroup) {
    let that = this;
    this.Server.send(
      "MainApi/getshopsFroApp",
      { shopGroup: shopGroup, getPayments: true },
      function (response) {
        let list = [];
        response.data.result.map((item) => {
          // let count = 0;
          // item.credit_payment.map((item2) => {
          //   if (item2.type == 1) {
          //     count++;
          //   }
          // });
          list.push({
            _id: item._id,
            title: item.name,
            image: item.logo,
            desc: item.address,
            mobile: item.mobile,
            call: item.call,
            // payCount: count,
          });
        });

        that.setState({
          list: list.sort((a, b) =>
            a.payCount > b.payCount ? -1 : b.payCount > a.payCount ? 1 : 0
          ),
          ShowLoading: false,
        });
      },
      function () {
        that.setState({
          ShowLoading: false,
        });
      }
    );
  }

  render() {
    return (
      <div style={{ height: "100%" }}>
        <div>
          <Header
            ComponentName="فروشگاههای طرف قرارداد "
            ComponentLName="app-icon-4"
          />
        </div>
        {!this.state.ShowLoading ? (
          <div>
            {this.state.shopGroups && this.state.shopGroups.length > 0 && (
              <div
                style={{ textAlign: "right", direction: "rtl", padding: 10 }}
              >
                <SelectButton
                  style={{ border: 0 }}
                  className="sarv-selectBotten"
                  value={this.state.shopGroup}
                  options={this.state.shopGroups}
                  onChange={(e) => {
                    this.setState({
                      shopGroup:
                        e.value === null ? this.state.shopGroup : e.value,
                    });
                    this.getshops(e.value);
                  }}
                ></SelectButton>
              </div>
            )}
            <div
              style={{ height: "100%", direction: "rtl", textAlign: "center" }}
            >
              {this.state.list &&
                this.state.list.map((item, index) => {
                  return (
                    <div key={index}>
                      <Link
                        to={`${process.env.PUBLIC_URL}/Shop?_id=${item._id}`}
                      >
                        <div className="cell">
                          <div className="child">
                            {item.image ? (
                              <div
                                style={{
                                  textAlign: "center",
                                  position: "relative",
                                }}
                              >
                                <img
                                  src={
                                    this.state.absoluteUrl +
                                    item.image.split("public")[1]
                                  }
                                  style={{ maxWidth: "100%", height: 200 }}
                                />
                                {/* <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                  }}
                                >
                                  <Tag
                                    severity={
                                      item.payCount > 0
                                        ? item.payCount > 100
                                          ? "success"
                                          : "info"
                                        : "warning"
                                    }
                                  >
                                    {item.payCount} خریدار
                                  </Tag>
                                </div> */}
                              </div>
                            ) : (
                              <div
                                style={{
                                  textAlign: "center",
                                  position: "relative",
                                }}
                              >
                                <img
                                  src="https://archive.org/download/no-photo-available/no-photo-available.png"
                                  style={{ maxWidth: "100%", height: 200 }}
                                />
                                {/* <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                  }}
                                >
                                  <Tag
                                    severity={
                                      item.payCount > 0
                                        ? item.payCount > 100
                                          ? "success"
                                          : "info"
                                        : "warning"
                                    }
                                  >
                                    {item.payCount} خریدار
                                  </Tag>
                                </div> */}
                              </div>
                            )}
                            <div> {item.title} </div>
                            <div className="ellipsis"> {item.desc} </div>
                            {item.call && (
                              <div>
                                {item.call.split(",").map((phone, index) => {
                                  return (
                                    <div key={index}>
                                      <a
                                        onClick={(event) => {
                                          event.stopPropagation();
                                        }}
                                        href={`tel:${phone}`}
                                      >
                                        {phone}
                                      </a>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                })}
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="2"
              fill="var(--surface-ground)"
              animationDuration=".5s"
            />
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    appData: state.appData,
    creditPrice: state.creditPrice,
    systemId: state.systemId,
  };
}
export default connect(mapStateToProps)(ShopList);
